import {
  Module,
  VuexModule,
  Action,
  Mutation,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  UPDATE_PROFILE,
  UPDATE_IP,
  GET_PROFILE,
  USERS_BALANCE,
  M_GET,
  M_PUT,
  M_POST,
} from '@/utils/api';

import serviceUtils from '@/services/utils';

import Vue from 'vue';

@Module({ name: 'profile' })
export default class Profile extends VuexModule {
  totalBalance: any = [];

  @Mutation
  mutateProfile(data) {
    this.totalBalance = data;
  }

  @Action
  UpdateProfile(user) {
    return Vue.axios({
      url: BASE_URL + UPDATE_PROFILE + user.userId,
      data: user,
      method: M_PUT,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }

  @Action
  UpdateIP(user) {
    return Vue.axios({
      url: BASE_URL + UPDATE_IP,
      data: user,
      method: M_PUT,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }

  @Action
  async FetchProfile() {
    const getPersist = await serviceUtils.getUserPersistent();
    return Vue.axios({
      url: BASE_URL + GET_PROFILE + getPersist.user._id,
      data: {},
      method: M_GET,
    })
      .then(({ data }) => {
        const { data: { profile, ipWhitelist }, status } = data;
        const userPersist = { ...getPersist };
        userPersist.user.profile = profile;
        userPersist.user.ipWhitelist = ipWhitelist;
        Vue.prototype.$session.set('ambgames-user-authenticate', JSON.stringify(userPersist));
        this.context.commit('setProfile', userPersist.user);
        return status;
      })
      .catch((err) => err);
  }

  @Action({ commit: 'mutateProfile' })
  async GetBalance() {
    const getPersist = await serviceUtils.getUserPersistent();
    return Vue.axios({
      url: BASE_URL + USERS_BALANCE,
      data: {},
      method: M_POST,
    }).then(({ data }) => {
      const { data: { wallet }, status } = data;
      const userPersist = { ...getPersist };
      userPersist.user.wallet.balance = wallet;
      Vue.prototype.$session.set('ambgames-user-authenticate', JSON.stringify(userPersist));
      this.context.commit('setProfile', userPersist.user);
      return { wallet, status };
    })
      .catch((err) => err);
  }
}
